import '@plone/volto/config';
import {
  ChannelsBlockView,
  ChannelsBlockEdit,
  EmbedBlockView,
  EmbedBlockEdit,
  FeaturedVideoEdit,
  FeaturedVideoView,
} from './components';
import { defineMessages } from 'react-intl';
import LiveChat from './components/theme/LiveChat';
import { getVar } from './helpers/utils';

import heroSVG from '@plone/volto/icons/hero.svg';
import { EPICS_TASK_VIEWS } from 'volto-epics-addon/constants';
import {
  TASK_LIVE_INFO_PROMPT,
  TASK_LIVE_JOBS_VIEW,
  AGREEMENT_PATH,
} from 'volto-m4-theme-addon/constants';
import LiveInfoPromptPage from 'volto-m4-theme-addon/components/theme/LiveStream/LiveInfoPromptPage';
import WaitLiveJobsPage from 'volto-m4-theme-addon/components/theme/LiveStream/WaitLiveJobsPage.jsx';
import AgreementPage from 'volto-m4-theme-addon/components/theme/Agreement/AgreementPage.jsx';
import AgreementRedirect from 'volto-m4-theme-addon/components/theme/Agreement/AgreementRedirect.jsx';
import Embed from 'volto-m4-theme-addon/components/manage/Embed/Embed';
import OEmbedHead from 'volto-m4-theme-addon/components/theme/OEmbedHead/OEmbedHead';
import memberUrl from 'volto-m4-theme-addon/reducers/member/memberUrl';
import memberFolder from 'volto-m4-theme-addon/reducers/member/memberFolder';
import videoIcon from '@plone/volto/icons/video.svg';

// For customizations
export const messages = defineMessages({
  startLiveStream: {
    id: 'startLiveStream',
    defaultMessage: 'Create a live stream',
  },
  university: {
    id: 'University of Jyväskylä',
    defaultMessage: 'University of Jyväskylä',
  },
  legacySearchText: {
    id: 'legacySearchText',
    defaultMessage:
      'We are currently migrating from an old version of the site to this new one. The content you are looking for might be present in the old site. You can try to find it at the same address on the old site:',
  },
  ifYouAreCertain: {
    id: 'ifYouAreCertain',
    defaultMessage:
      'If you are certain you have the correct web address but are encountering an error, please',
  },
  contactUs: {
    id: 'contactUs',
    defaultMessage: 'contact us.',
  },
});

const applyConfig = (config) => {
  if (getVar('RAZZLE_LIVE_PAGE_CHAT_ENABLED') === 'true') {
    config.registerComponent({ name: 'LiveChat', component: LiveChat });
  }
  config.settings.isMultilingual = true;
  config.settings.supportedLanguages = ['fi', 'en'];
  config.settings.defaultLanguage = 'fi';
  config.settings.defaultUseInitialPrompt = false;

  // Restrict the navigation API expander to language-root paths only.
  // Without this, GET_CONTENT_SUCCESS for paths outside a language root
  // (e.g. /Members/member-1) clobbers the navigation store with site-root
  // nav items. The Navigation component override fetches from /<lang> instead.
  const langPattern = config.settings.supportedLanguages.join('|');
  config.settings.apiExpanders = config.settings.apiExpanders.map((exp) =>
    exp.GET_CONTENT?.includes('navigation') && exp.match === ''
      ? { ...exp, match: `/:lang(${langPattern})` }
      : exp,
  );
  config.settings.appExtras = [
    ...config.settings.appExtras,
    {
      match: {
        path: '*',
        ignore: ['**/login', '**/logout'],
      },
      component: AgreementRedirect,
    },
    { match: '/', component: OEmbedHead },
  ];

  // Channels block configuration
  config.blocks.blocksConfig.channels = {
    id: 'channels',
    title: 'Channels',
    icon: heroSVG,
    group: 'common',
    view: ChannelsBlockView,
    edit: ChannelsBlockEdit,
    restricted: false,
    mostUsed: true,
    sidebarTab: 1,
  };

  // Embed block configuration
  config.blocks.blocksConfig.embedmedia = {
    id: 'embedmedia',
    title: 'Embed',
    icon: heroSVG,
    group: 'common',
    view: EmbedBlockView,
    edit: EmbedBlockEdit,
    restricted: false,
    mostUsed: true,
    sidebarTab: 1,
  };
  // Featured video block configuration
  config.blocks.blocksConfig.featuredVideo = {
    id: 'featuredVideo',
    title: 'Featured video',
    icon: videoIcon,
    group: 'common',
    view: FeaturedVideoView,
    edit: FeaturedVideoEdit,
    mostUsed: true,
  };

  config.addonRoutes.push(
    ...[
      {
        path: EPICS_TASK_VIEWS[TASK_LIVE_INFO_PROMPT],
        component: LiveInfoPromptPage,
      },
      {
        path: EPICS_TASK_VIEWS[TASK_LIVE_JOBS_VIEW],
        component: WaitLiveJobsPage,
      },
      {
        path: AGREEMENT_PATH,
        component: AgreementPage,
      },
    ],
  );

  (config.settings.addonMainRoutes =
    config.settings.addonMainRoutes || []).push({
    path: '/embed',
    component: Embed,
    routes: [],
  });

  config.settings.nonContentRoutes = [
    ...config.settings.nonContentRoutes,
    EPICS_TASK_VIEWS[TASK_LIVE_INFO_PROMPT],
    EPICS_TASK_VIEWS[TASK_LIVE_JOBS_VIEW],
    AGREEMENT_PATH,
  ];

  config.addonReducers = {
    ...config.addonReducers,
    memberUrl,
    memberFolder,
  };

  return config;
};

export default applyConfig;
